import { cn } from "@ui/lib";
import type { ReactNode } from "react";

/** 首页 H2 的 DeeVid 排版（DESIGN.md §7.6.1），CTA 卡等不走 HomeSection 的地方也用 */
export const HOME_H2_CLASS =
	"font-semibold text-[clamp(28px,4vw,48px)] text-gray-12 leading-[1.2] tracking-heading";

/**
 * 首页区块外壳：白底、72px 上下留白（2026-10-05 由 90 收紧）、1280 容器（2026-10-05 由 1420 收窄，内容边缘对齐导航栏）。
 * 纯展示，不引 server-only 模块，客户端组件（Testimonials）也能用。
 */
export function HomeSection({
	id,
	title,
	description,
	align = "center",
	className,
	children,
}: {
	id?: string;
	title: string;
	/** 可带内链（t.rich 的结果），所以收 ReactNode */
	description?: ReactNode;
	align?: "left" | "center";
	className?: string;
	children: ReactNode;
}) {
	return (
		<section id={id} className={cn("py-10 lg:py-[72px]", className)}>
			<div className="mx-auto max-w-[1280px] px-4 sm:px-6">
				<div
					className={cn(
						"mb-10 lg:mb-12",
						align === "center" && "mx-auto text-center",
					)}
				>
					<h2 className={HOME_H2_CLASS}>{title}</h2>
					{description ? (
						<p
							className={cn(
								"mt-4 max-w-[885px] font-light text-[clamp(16px,1.6vw,20px)] text-gray-12 leading-normal",
								align === "center" && "mx-auto",
							)}
						>
							{description}
						</p>
					) : null}
				</div>
				{children}
			</div>
		</section>
	);
}
